import { createContext } from 'react';

import { ModeContextType } from './ModeContext.types';

const initialContext: ModeContextType = {
  mode: '',
};

export const ModeContext = createContext(initialContext);
